<h2 class="title">
  Teste - {{ (test.name.length > 20) ? (test.name | slice:0:20) +'...' : (test.name) }}
  | <span class="sub-title">{{ subTitle }}</span>
</h2>

<p *ngIf="!test.canEdit" class="alert-text">
  * As telas customizadas que estão vinculadas a algum processo seletivo não podem ser editadas.
</p>
